export default __webpack_public_path__ + "static/media/ritual-make1.83af4c61.png";